import { useRef, useEffect } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import useNearScreen from 'hooks/use-near-screen'
import ProjectProgress from './project-progress'
import ProjectStatus from './project-status'
import ProjectDescription from './project-description'

const ProjectCardStyled = styled.div`
  margin-bottom: 64px;
  .project-thumb {
    border-radius: 8px;
    max-height: 350px;
    overflow: hidden;
    margin-bottom: 16px;
    position: relative;
  }
  .git-link {
    font-size: 14px;
    line-height: 24px;
    display: flex;
    cursor: pointer;
    align-items: center;
    margin-bottom: 24px;
    a {
      margin-left: .5em;
    }
  }
  .thumb-image {
    width: 100%;
    height: auto;
  }
  @media(min-width: 768px) {
    margin-bottom: 0;
    .git-link {
      font-size: 16px;
    }
  }
`

function ProjectCard({
  title, slug, thumb_image, description: { blocks }, progress_status, scroll,
}) {
  const [show, element] = useNearScreen({ threshold: 1.0 })
  const projectCard = useRef()
  const { asPath } = useRouter()
  useEffect(() => {
    const card = projectCard.current
    if (card && scroll) {
      if (asPath.includes(card.id)) {
        window.scrollTo(0, card.getBoundingClientRect().y - 80)
      }
    }
  }, [])
  return (
    <ProjectCardStyled data-cy="student-project" id={slug} ref={projectCard}>
      <div className="project-thumb" ref={element}>
        <ProjectStatus show={show} {...progress_status} />
        <img className="thumb-image" width="588" height="441" src={thumb_image} alt={`Pequeña miniatura del proyecto de ${title}`} />
      </div>
      <ProjectDescription {...progress_status} title={title} blocks={blocks} />
      <ProjectProgress progressStatus={progress_status || {}} project={slug} />
    </ProjectCardStyled>
  )
}

ProjectCard.defaultProps = {
  scroll: false,
}

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  thumb_image: PropTypes.string.isRequired,
  scroll: PropTypes.bool,
}

export default ProjectCard
